import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../BaseController'
import { ButtonAPI, ImageAPI } from '@philips-internal/oswald-ui-components';
import { Inject } from '@odinjs/odin';
import ConfigurationService from '../../services/configuration-service';
import { APPLICATION_ROUTES } from '../../constants/application-routes';

@Controller({ component: 'success-layout', fragment: 'reset-password-request-success' })
class ResetPasswordRequestSuccessController extends BaseController {
  @Inject('title-image')
    ImageHeader!: ImageAPI;

  @Inject('ok-button')
    loginButton!: ButtonAPI;

  @OnMount({ target: ['success-layout'] })
  onMount(): void {
    ConfigurationService.getConfigurationData().then(layoutData => {
      this.ImageHeader.setSrc(layoutData.dsUrlLogoHeaderLogin);

    })
  }
  @OnClick({ target: 'ok-button' })
  onClickLoginButton(): void {
    this.historyService.push(APPLICATION_ROUTES.LOGIN);
  }

}

export default ResetPasswordRequestSuccessController;
